export const WEBHOOK_CREATE_WEBHOOK_BEGIN = 'WEBHOOK_CREATE_WEBHOOK_BEGIN';
export const WEBHOOK_CREATE_WEBHOOK_SUCCESS = 'WEBHOOK_CREATE_WEBHOOK_SUCCESS';
export const WEBHOOK_CREATE_WEBHOOK_FAILURE = 'WEBHOOK_CREATE_WEBHOOK_FAILURE';
export const WEBHOOK_CREATE_WEBHOOK_DISMISS_ERROR = 'WEBHOOK_CREATE_WEBHOOK_DISMISS_ERROR';
export const WEBHOOK_LIST_WEBHOOKS_BEGIN = 'WEBHOOK_LIST_WEBHOOKS_BEGIN';
export const WEBHOOK_LIST_WEBHOOKS_SUCCESS = 'WEBHOOK_LIST_WEBHOOKS_SUCCESS';
export const WEBHOOK_LIST_WEBHOOKS_FAILURE = 'WEBHOOK_LIST_WEBHOOKS_FAILURE';
export const WEBHOOK_LIST_WEBHOOKS_DISMISS_ERROR = 'WEBHOOK_LIST_WEBHOOKS_DISMISS_ERROR';
export const WEBHOOK_LOAD_WEBHOOK_DETAILS_BEGIN = 'WEBHOOK_LOAD_WEBHOOK_DETAILS_BEGIN';
export const WEBHOOK_LOAD_WEBHOOK_DETAILS_SUCCESS = 'WEBHOOK_LOAD_WEBHOOK_DETAILS_SUCCESS';
export const WEBHOOK_LOAD_WEBHOOK_DETAILS_FAILURE = 'WEBHOOK_LOAD_WEBHOOK_DETAILS_FAILURE';
export const WEBHOOK_LOAD_WEBHOOK_DETAILS_DISMISS_ERROR =
  'WEBHOOK_LOAD_WEBHOOK_DETAILS_DISMISS_ERROR';
export const WEBHOOK_UPDATE_WEBHOOK_BEGIN = 'WEBHOOK_UPDATE_WEBHOOK_BEGIN';
export const WEBHOOK_UPDATE_WEBHOOK_SUCCESS = 'WEBHOOK_UPDATE_WEBHOOK_SUCCESS';
export const WEBHOOK_UPDATE_WEBHOOK_FAILURE = 'WEBHOOK_UPDATE_WEBHOOK_FAILURE';
export const WEBHOOK_UPDATE_WEBHOOK_DISMISS_ERROR = 'WEBHOOK_UPDATE_WEBHOOK_DISMISS_ERROR';
export const WEBHOOK_DELETE_WEBHOOK_BEGIN = 'WEBHOOK_DELETE_WEBHOOK_BEGIN';
export const WEBHOOK_DELETE_WEBHOOK_SUCCESS = 'WEBHOOK_DELETE_WEBHOOK_SUCCESS';
export const WEBHOOK_DELETE_WEBHOOK_FAILURE = 'WEBHOOK_DELETE_WEBHOOK_FAILURE';
export const WEBHOOK_DELETE_WEBHOOK_DISMISS_ERROR = 'WEBHOOK_DELETE_WEBHOOK_DISMISS_ERROR';
export const WEBHOOK_GET_PERMISSION_FLAGS_BEGIN = 'WEBHOOK_GET_PERMISSION_FLAGS_BEGIN';
export const WEBHOOK_GET_PERMISSION_FLAGS_SUCCESS = 'WEBHOOK_GET_PERMISSION_FLAGS_SUCCESS';
export const WEBHOOK_GET_PERMISSION_FLAGS_FAILURE = 'WEBHOOK_GET_PERMISSION_FLAGS_FAILURE';
export const WEBHOOK_GET_PERMISSION_FLAGS_DISMISS_ERROR = 'WEBHOOK_GET_PERMISSION_FLAGS_DISMISS_ERROR';
